// Department and project names for the Warning Dashboard screens (BUG: "null labels").
//
// Every screen used to carry its own copy of a 7-department list and fell back to "Department #16" /
// "Department #null" for anyone else - and people from other departments DO show up in the rows (GCC, MEL,
// Magic Lamp, ...), and so do people with no department at all. This is the full department list (ids and
// names as in the `department` table), so a person from any department gets a real name, and a missing id
// reads "-" instead of "#null". A screen still passes its own short names first (OGD, CSD, Foundation, ...).

const OTHER_DEPARTMENTS = {
  1: 'Top Management',
  2: 'Human Resource (HR)',
  4: 'Marketing',
  5: 'Technical Department',
  6: 'Academics',
  7: 'Finance',
  8: 'Creative Department',
  9: 'Research and Development',
  10: 'Procurement',
  13: 'Operations (Project Administration)',
  14: 'Digital Marketing Department',
  15: 'Talent Acquisitions',
  16: 'GCC',
  17: 'Project Coordination',
  19: 'Operations (Data Management)',
  23: 'Personal Mentor',
  24: 'Operations-General',
  25: 'General Administration',
  26: 'MEL',
  27: 'Strategy Development Cell',
  29: 'Magic Lamp (D2C)',
  30: 'Project-Open School',
  31: 'Learning and Development',
  33: 'Audit Department',
  34: "Founder's Office",
  37: 'Digital Marketing',
  38: 'Magic Lamps Offline',
};

const isMissing = (id) => id === null || id === undefined || id === '';

// preferred = the screen's own [{ id, name }] short names
export const departmentLabel = (id, preferred = []) => {
  if (isMissing(id)) return '-';
  const n = Number(id);
  return preferred.find((d) => d.id === n)?.name || OTHER_DEPARTMENTS[n] || 'Other department';
};

export const projectLabel = (id, preferred = []) => {
  if (isMissing(id)) return '-';
  return preferred.find((p) => p.id === Number(id))?.name || 'Other project';
};
